import { setLoading, setList, selectById } from './serviceSlice';

const services = [
  {
    value: 1,
    label: 'Application for Issuance of a Certificate of Public Convenience'
  }
]

export const list = () => dispatch => {
  dispatch(setLoading(true))
  
  setTimeout(() => {
    dispatch([
      setList(services),
      setLoading(false)
    ])
  }, 2000);
} 

export const show = (id) => dispatch => {
  dispatch(selectById(id))
}